import { startAuthentication, startRegistration, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { api } from './api';

export const KEY = (who) => `bond_passkey_${who}`;

export async function canUseBiometric() {
  if (!browserSupportsWebAuthn() || !window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return false;
  try { return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(); } catch { return false; }
}

export const deviceLabel = () => {
  const ua = navigator.userAgent;
  const os = /iPhone|iPad/.test(ua) ? 'iPhone/iPad' : /Android/.test(ua) ? 'Android' : /Mac/.test(ua) ? 'Mac' : /Windows/.test(ua) ? 'Windows' : 'Dispositivo';
  const br = /Edg\//.test(ua) ? 'Edge' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : /Firefox\//.test(ua) ? 'Firefox' : '';
  return `${os}${br ? ` · ${br}` : ''}`;
};

// base: '/auth/passkeys' (portal api) or full admin axios wrapper via `client`
export async function enroll(client, base) {
  const { data } = await client.post(`${base}/register/options`);
  const credential = await startRegistration({ optionsJSON: data });
  return client.post(`${base}/register/verify`, { credential, label: deviceLabel() });
}

export async function verifyBiometric(client, base, mfaToken) {
  const { data } = await client.post(`${base}/mfa/options`, { mfa_token: mfaToken });
  const credential = await startAuthentication({ optionsJSON: data });
  return (await client.post(`${base}/mfa/verify`, { mfa_token: mfaToken, credential })).data;
}

export const portalClient = api;
